import React from "react";
import PropTypes from "prop-types";
import elli from "../images/elli.png";

import "../styles/global.css";

const PRACTICE = {
  name: "Praxis Elvira Rühl",
  street: "Amsterdamer Straße 10",
  city: "40474 Düsseldorf",
  phone: "0211 8628085"
};

const Layout = ({ children }) => (
  <>
    <div className="app">
      <header>
        <img src={elli} alt="" className="elli" />
        <h1>Elvira Rühl</h1>
        <h2>Ihre Osteopathin in Düsseldorf </h2>
        <div className="address">
          {PRACTICE.name} <br />
          {PRACTICE.street} <br />
          {PRACTICE.city} <br />
          Tel: {PRACTICE.phone}
        </div>
      </header>
      <div className="container">{children}</div>
      <footer>
        © {new Date().getFullYear()} ∙ {PRACTICE.name} ∙ {PRACTICE.street} ∙{" "}
        {PRACTICE.city} ∙ Tel. {PRACTICE.phone} ∙{" "}
        <a href="https://www.duesseldorf-osteopath.de/j/privacy">
          Datenschutzerklärung
        </a>{" "}
        ∙ <a href="https://www.duesseldorf-osteopath.de/about/">Impressum</a>{" "}
        ∙ V. 1.1.0
      </footer>
    </div>
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
